/**
 * Extracts the status code from an error object.
 */
export const extractStatusCode = (error: any): number | 'unknown' => {
    const statusMatch = error?.toString().match(/status: (\d+)/);
    return statusMatch ? parseInt(statusMatch[1], 10) : 'unknown';
};
